import {
	type ExperienceData,
	FMP_MARK,
	type PageLoadExperienceData,
	type ExperiencePerformanceConfig as PerformanceConfig,
} from '@atlassian/ufo-experimental/types';

import { type SSRConfig } from '../../types';
import { isInitialPageLoad } from '../utils/is-initial-page-load';

import { getHistogram } from './getHistogram';
import { LoadMetricKeys } from './LoadMetricKeys';

export const getLoadMetrics = (
	data: ExperienceData | PageLoadExperienceData,
	ssr: SSRConfig | null,
	performanceConfig: PerformanceConfig | null,
): {
	[x: string]: string | number;
} | null => {
	if (data.metrics.endTime === null || data.metrics.startTime === null) {
		return null;
	}

	const fmpMark =
		data.metrics.marks.find((mark) => mark.name === FMP_MARK)?.time ||
		(isInitialPageLoad(data) && ssr?.getDoneMark());
	const tti = data.metrics.endTime - data.metrics.startTime;
	const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
	return {
		[LoadMetricKeys.tti]: Math.round(tti),
		[LoadMetricKeys.fmp]: Math.round(fmp),
		...getHistogram(data, performanceConfig),
	};
};
